import { Reducer } from 'redux';
import {
  DeskState,
  GET_DESK_LIST,
  DeskActionTypes,
  GET_DESK,
  POST_DESK,
  PUT_DESK,
  DELETE_DESK,
  UPDATE_DESK_FILTERS
} from '../types/desk.types';

const initialState: DeskState = {
  desks: [],
  selectedDesk: null,
  postSuccess: null,
  lastFetch: null,
  totalElements: 0,
  totalPages: 1,
  filters: null
};

export const deskReducer: Reducer<DeskState> = (
  state: DeskState = initialState, action
) => {
  const timeOfAction = new Date().getTime();
  switch ((action as DeskActionTypes).type) {
    case GET_DESK_LIST:
      return {
        ...state,
        desks: action.payload.page.content,
        postSuccess: null,
        lastFetch: timeOfAction,
        totalPages: action.payload.page.totalPages,
        totalElements: action.payload.page.totalElements
      };
    case GET_DESK:
      return {
        ...state,
        postSuccess: null,
        selectedDesk: action.payload.selectedDesk,
        lastFetch: timeOfAction
      };
    case POST_DESK:
      return {
        ...state,
        postSuccess: true,
        selectedDesk: action.payload.selectedDesk,
        lastFetch: timeOfAction
      };
    case PUT_DESK:
      return {
        ...state,
        selectedDesk: action.payload.selectedDesk,
        postSuccess: true,
        lastFetch: timeOfAction
      };
    case DELETE_DESK:
      return {
        ...state,
        selectedDesk: null,
        lastFetch: timeOfAction
      };
    case UPDATE_DESK_FILTERS:
      return {
        ...state,
        filters: action.payload.filters
      };
    default:
      return state;
  }
};
